import _extends from "@babel/runtime/helpers/extends";
import React, { useContext } from 'react';
import { HashRouter, Route } from 'react-router-dom';
import LoruleNav from './LoruleNav';
import LoruleBody from './LoruleBody';
import LoruleFooter from './LoruleFooter';
import UserContext from '../contexts/UserContext';
import LocalizationContext from '../contexts/LocalizationContext';

var BaseLoruleApplication = function BaseLoruleApplication(_ref) {
  var authState = _ref.authState,
      tabs = _ref.tabs,
      routes = _ref.routes,
      userConfig = _ref.userConfig,
      navHeaderCustom = _ref.navHeaderCustom,
      appName = _ref.appName,
      defaultPath = _ref.defaultPath,
      loadingCustom = _ref.loadingCustom,
      logoutCustom = _ref.logoutCustom,
      language = _ref.language,
      userDropDownItems = _ref.userDropDownItems,
      dropDownMenus = _ref.dropDownMenus;
  var localizedStrings = useContext(LocalizationContext);

  if (language) {
    localizedStrings.setLanguage(language);
  }

  return /*#__PURE__*/React.createElement(UserContext.Provider, {
    value: authState.userInfo
  }, /*#__PURE__*/React.createElement(HashRouter, null, /*#__PURE__*/React.createElement(Route, {
    render: function render(routeProps) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(LoruleNav, _extends({}, routeProps, {
        appName: appName,
        defaultPath: defaultPath,
        userInfo: authState.userInfo,
        roles: authState.roles,
        componentTabs: tabs,
        userConfig: userConfig,
        navHeaderCustom: navHeaderCustom,
        userDropDownItems: userDropDownItems,
        dropDownMenus: dropDownMenus
      })), /*#__PURE__*/React.createElement(LoruleBody, {
        authState: authState,
        defaultPath: defaultPath,
        routes: routes,
        loadingCustom: loadingCustom,
        loggedOutCustom: logoutCustom
      }), /*#__PURE__*/React.createElement(LoruleFooter, null));
    }
  })));
};

export default BaseLoruleApplication;